<img *ngIf="imageUrl(); else initialsTemplate"
     class="xp-avatar__image"
     [src]="imageUrl()"
     [alt]="alt()" />
<ng-template #initialsTemplate>
	<span class="xp-avatar__initials">{{ initials() }}</span>
</ng-template>
